import {
  apiRequest,
  positionEselon,
  positionRank,
  positionWorkUnit,
  positionDraft,
  positionSubmitDraft,
  positionDetailDraft,
  positionDeleteDraft,
  positionUpdateDraft,
} from "../../../../../services/adapters/master/positionService";

class DraftRepository {
  fetchEselon = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionEselon,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionWorkUnit,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchRank = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionRank,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchDraft = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionDraft,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchSubmit = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      positionSubmitDraft,
      {
        body: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      positionDetailDraft,
      {
        params: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchDelete = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      positionDeleteDraft,
      {
        body: query,
        cancelToken: cancelToken,
      },
      true
    );
  };

  fetchUpdate = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      positionUpdateDraft,
      {
        body: query,
        cancelToken: cancelToken,
      },
      true
    );
  };
}

export default DraftRepository;
